<template>
  <v-container fluid tag="section" class="text_google login-page">
    <!-- ป้ายประกาศเปิดปรับข้อมูลส่วนตัว ด้านวุฒิลูกเสือ — ให้เห็นเด่นชัดเป็นอันดับแรกของหน้าแรกระบบ -->
    <v-row v-if="scoutPeriod.open" justify="center">
      <v-col cols="12" md="10">
        <v-alert
          border="left"
          colored-border
          color="success"
          elevation="4"
          class="scout-banner"
          icon="mdi-tent"
          prominent
        >
          <div class="d-flex align-center flex-wrap">
            <div class="flex-grow-1">
              <div class="scout-banner-title">
                <v-icon color="success" class="mr-1">mdi-bullhorn-outline</v-icon>
                เปิดให้ปรับข้อมูลส่วนตัว ด้านวุฒิลูกเสือแล้ว
              </div>
              <div class="scout-banner-desc">
                สำหรับบุคลากรที่มีข้อมูลลูกเสือวิสามัญอาชีวศึกษา สามารถเข้าสู่ระบบแล้วดำเนินการปรับปรุงข้อมูลได้ตั้งแต่วันนี้<span v-if="scoutPeriod.stop">
                  ถึงวันที่ <strong>{{ scoutPeriod.stop | moment("add", "543 years") | moment("D MMMM YYYY") }}</strong></span>
              </div>
            </div>
          </div>
        </v-alert>
      </v-col>
    </v-row>

    <!-- รายการตรวจสอบความพร้อมของระบบ (โดยละเอียด) — แสดงเสมอ ไม่บล็อกการใช้งาน
         ช่วยให้ผู้ใช้งาน/ผู้ดูแลระบบวินิจฉัยเบื้องต้นได้เองว่า "เข้าระบบไม่ได้" เกิดจากชั้นไหน -->
    
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" sm="6"><Loginuser /></v-col>
          <v-col cols="12" sm="6"><LoginCollege /></v-col>
          <v-col cols="12" sm="6"><Loginuser_gov /></v-col>
          <v-col cols="12" sm="6"><LoginuserEtc /></v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="4">
      <v-card outlined class="readiness-card">
          <div class="readiness-header" @click="readinessExpanded = !readinessExpanded">
            <v-icon :color="readinessSummary.color" class="mr-2">{{ readinessSummary.icon }}</v-icon>
            <div class="flex-grow-1">
              <div class="readiness-title">ตรวจสอบความพร้อมของระบบ</div>
              <div class="readiness-summary" :class="'readiness-summary--' + readinessSummary.color">
                {{ readinessSummary.text }}
              </div>
            </div>
            <v-btn icon small :loading="readinessChecking" @click.stop="runSystemReadinessCheck">
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
            <v-btn icon small>
              <v-icon small>{{ readinessExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
            </v-btn>
          </div>

          <v-expand-transition>
            <div v-show="readinessExpanded">
              <v-divider></v-divider>
              <v-list dense class="readiness-list">
                <v-list-item v-for="item in readinessChecks" :key="item.key" class="readiness-item">
                  <v-list-item-icon class="mr-3">
                    <v-progress-circular
                      v-if="item.status === 'checking' || item.status === 'pending'"
                      indeterminate
                      size="18"
                      width="2"
                      color="grey"
                    ></v-progress-circular>
                    <v-icon v-else :color="statusColor(item.status)">{{ statusIcon(item.status) }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="readiness-item-label">{{ item.label }}</v-list-item-title>
                    <v-list-item-subtitle class="readiness-item-detail">
                      {{ item.detail || "กำลังตรวจสอบ..." }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div class="readiness-footer">
                ตรวจสอบล่าสุด: {{ lastCheckedLabel }}
              </div>
            </div>
          </v-expand-transition>
        </v-card>


        <v-card rounded="lg" elevation="2" class="group-guide-card">
          <v-card-title class="guide-title">
            <v-icon left color="primary">mdi-information-outline</v-icon>
            คำอธิบายการเข้าใช้งานแต่ละกลุ่มผู้ใช้
          </v-card-title>
          <v-card-text>
            <div class="guide-item">
              <div class="guide-item-header">
                <span class="guide-dot" style="background:#455a64"></span>
                <span class="guide-name">ข้าราชการครูและบุคลากรทางการศึกษา</span>
              </div>
              <p class="guide-desc">
                สำหรับครู ผู้อำนวยการ รองผู้อำนวยการ และพนักงานราชการ ใช้ <strong>เลขบัตรประชาชน</strong> เป็นชื่อผู้ใช้งาน
              </p>
              <div class="guide-thaid-row">
              
                <v-chip  color="primary" outlined class="guide-thaid-chip">
                    <v-img width="80" src="thai-id.png" alt="ThaiID" class="guide-thaid-img"></v-img>
                  <v-icon left x-small>mdi-qrcode-scan</v-icon>ยืนยันตัวตนผ่าน ThaiID ทุกบัญชี
                </v-chip>
                <a href="#" class="thaid-link" @click.prevent="showThaidInfo = true">ดูขั้นตอน</a>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="guide-item">
              <div class="guide-item-header">
                <span class="guide-dot" style="background:#e53e3e"></span>
                <span class="guide-name">ผู้ดูแลระบบ / สถานศึกษา / สถาบัน / สอจ.</span>
              </div>
              <p class="guide-desc">
                สำหรับหน่วยงาน (วิทยาลัย สถาบันการอาชีวศึกษา สำนักงานอาชีวศึกษาจังหวัด) และผู้ดูแลระบบส่วนกลาง ใช้ <strong>รหัสหน่วยงาน</strong> เป็นชื่อผู้ใช้งาน
              </p>
              <div class="guide-thaid-row">               
                <v-chip color="primary" outlined class="guide-thaid-chip">
                  <v-img width="80" src="thai-id.png" alt="ThaiID" class="guide-thaid-img"></v-img>
                  <v-icon left x-small>mdi-qrcode-scan</v-icon>ยืนยันตัวตนผ่าน ThaiID
                </v-chip>
                <a href="#" class="thaid-link" @click.prevent="showThaidInfo = true">ดูขั้นตอน</a>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="guide-item">
              <div class="guide-item-header">
                <span class="guide-dot" style="background:#b3151b"></span>
                <span class="guide-name">พนักงานราชการ</span>
              </div>
              <p class="guide-desc">
                สำหรับพนักงานราชการในสังกัด ใช้ <strong>เลขบัตรประชาชน</strong> เป็นชื่อผู้ใช้งาน
              </p>
               <v-chip color="primary" outlined class="guide-thaid-chip">
                  <v-img width="80" src="thai-id.png" alt="ThaiID" class="guide-thaid-img"></v-img>
                  <v-icon left x-small>mdi-qrcode-scan</v-icon>ยืนยันตัวตนผ่าน ThaiID
                </v-chip>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="guide-item">
              <div class="guide-item-header">
                <span class="guide-dot" style="background:#a86400"></span>
                <span class="guide-name">บุคลากรทางการศึกษาอื่น</span>
              </div>
              <p class="guide-desc">
                สำหรับครูอัตราจ้าง ลูกจ้างประจำ และลูกจ้างชั่วคราว ใช้ <strong>เลขบัตรประชาชน / Passport / รหัสประจำตัวประชาชน</strong> เป็นชื่อผู้ใช้งาน
              </p>
            </div>

            <v-alert dense outlined color="grey darken-1" class="mt-4 mb-0 guide-note">
              <v-icon left small color="grey darken-1">mdi-help-circle-outline</v-icon>
              ไม่แน่ใจว่าเป็นกลุ่มใด กรุณาติดต่อผู้ดูแลระบบของหน่วยงานท่าน
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-2 mb-8">
      <v-col cols="12" md="10">
        <v-alert
          border="left"
          colored-border
          color="primary"
          elevation="2"
          class="manual-banner"
          icon="mdi-shield-check-outline"
        >
          <div class="d-flex align-center flex-wrap">
            <div class="flex-grow-1">
              <strong>ระบบมีการอัปเดตความปลอดภัย</strong> — บางบัญชีอาจได้รับแจ้งให้ตั้งรหัสผ่านใหม่ทันทีหลังเข้าสู่ระบบ
              ถือเป็นขั้นตอนปกติเพื่อความปลอดภัยของท่าน
              <a href="#" class="info-link" @click.prevent="showPasswordInfo = true">
                อ่านรายละเอียดกระบวนการจัดการรหัสผ่าน
              </a>
            </div>
            <v-btn color="primary" to="/news" rounded outlined class="ml-auto mt-2 mt-sm-0">
              <v-icon left small>mdi-book-open-page-variant</v-icon>คู่มือการใช้งาน
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>

    <!-- อธิบายกระบวนการจัดการรหัสผ่านแบบละเอียด — เปิดจากลิงก์ในป้ายประกาศด้านบน
         ตั้งใจไม่ระบุรูปแบบ/ตัวอย่างรหัสผ่านเริ่มต้นไว้ตรงนี้ เพื่อไม่เปิดเผยข้อมูลที่ผู้ไม่ประสงค์ดี
         อาจนำไปใช้เดารหัสผ่านได้ -->
    <v-dialog v-model="showPasswordInfo" max-width="600">
      <v-card rounded="xl" class="password-info-card">
        <v-card-title class="password-info-header white--text">
          <v-icon left color="white">mdi-lock-check-outline</v-icon>
          กระบวนการจัดการรหัสผ่าน
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">1</v-avatar>
            <div>
              <strong>เข้าใช้งานครั้งแรก หรือจำรหัสผ่านไม่ได้</strong>
              <p class="mb-0 grey--text text--darken-1">
                กรุณาติดต่อผู้ดูแลระบบของหน่วยงานท่าน หรือกดปุ่ม "ลืมรหัสผ่าน" ในหน้าเข้าสู่ระบบของแต่ละประเภทผู้ใช้งานด้านบน
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">2</v-avatar>
            <div>
              <strong>ระบบขอให้ตั้งรหัสผ่านใหม่ทันทีที่เข้าสู่ระบบ</strong>
              <p class="mb-0 grey--text text--darken-1">
                เป็นส่วนหนึ่งของการยกระดับความปลอดภัยของระบบ ไม่ใช่ความผิดพลาดของท่าน กรุณาตั้งรหัสผ่านใหม่ตามที่ระบบแนะนำก่อนใช้งานต่อ
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">3</v-avatar>
            <div>
              <strong>ลืมรหัสผ่าน</strong>
              <p class="mb-0 grey--text text--darken-1">
                กดปุ่ม "ลืมรหัสผ่าน" ในหน้าเข้าสู่ระบบ ระบบจะส่งรหัสยืนยัน (OTP) ไปยังอีเมลที่ลงทะเบียนไว้ในระบบเท่านั้น
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">4</v-avatar>
            <div>
              <strong>การตั้งรหัสผ่านที่ปลอดภัย</strong>
              <p class="mb-0 grey--text text--darken-1">
                อย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรและตัวเลขอย่างน้อยอย่างละ 1 ตัว และไม่ควรใช้ซ้ำกับรหัสผ่านที่ใช้ในระบบอื่น
              </p>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" rounded @click="showPasswordInfo = false">เข้าใจแล้ว</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ขั้นตอนการยืนยันตัวตนผ่าน ThaiID — เปิดจากลิงก์ "ดูขั้นตอน" ในการ์ดคำอธิบายกลุ่มผู้ใช้งานด้านบน -->
    <v-dialog v-model="showThaidInfo" max-width="600">
      <v-card rounded="xl" class="password-info-card">
        <v-card-title class="thaid-info-header white--text">
          <v-icon left color="white">mdi-qrcode-scan</v-icon>
          ขั้นตอนการยืนยันตัวตนผ่าน ThaiID 
        </v-card-title>
        <v-card-text class="pt-6">
          <p class="thaid-intro">
            ThaiID คือแอปพลิเคชันยืนยันตัวตนทางดิจิทัล ออกให้โดย<strong>กรมการปกครอง กระทรวงมหาดไทย</strong>
            ใช้เป็นการยืนยันตัวตนขั้นที่สอง (นอกเหนือจากรหัสผ่าน) สำหรับบัญชีบางกลุ่มของระบบนี้
          </p>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">1</v-avatar>
            <div>
              <strong>กรอกชื่อผู้ใช้งานและรหัสผ่านตามปกติ</strong>
              <p class="mb-0 grey--text text--darken-1">
                เข้าสู่ระบบตามขั้นตอนเดิมทุกอย่าง หากรหัสผ่านถูกต้อง ระบบจะพาไปขั้นตอนถัดไปโดยอัตโนมัติ
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">2</v-avatar>
            <div>
              <strong>ระบบพาไปหน้ายืนยันตัวตนของ ThaiID</strong>
              <p class="mb-0 grey--text text--darken-1">
                หน้าจอจะเปลี่ยนไปยังเว็บไซต์ของกรมการปกครองโดยอัตโนมัติ พร้อมแสดง QR Code สำหรับสแกน
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start mb-5">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">3</v-avatar>
            <div>
              <strong>สแกน QR Code ด้วยแอป ThaID</strong>
              <p class="mb-0 grey--text text--darken-1">
                เปิดแอป ThaID บนโทรศัพท์มือถือ สแกน QR Code บนหน้าจอ แล้วยืนยันตัวตนด้วย PIN ของท่านในแอป
              </p>
            </div>
          </div>
          <div class="info-step d-flex align-start">
            <v-avatar size="32" color="primary" class="white--text mr-3 flex-shrink-0">4</v-avatar>
            <div>
              <strong>เข้าสู่ระบบสำเร็จโดยอัตโนมัติ</strong>
              <p class="mb-0 grey--text text--darken-1">
                เมื่อยืนยันตัวตนผ่าน ThaID สำเร็จ ระบบจะพาท่านกลับเข้าสู่ระบบ HRVEC ให้อัตโนมัติ ไม่ต้องกรอกข้อมูลซ้ำ
              </p>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" rounded @click="showThaidInfo = false">เข้าใจแล้ว</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import LoginCollege from "../components/core/loginCollege.vue";
import Loginuser from "../components/core/loginuser.vue";
import Loginuser_gov from "../components/core/loginuser_gov.vue";
import LoginuserEtc from "../components/core/loginuserEtc.vue";

export default {
  components: {
    Loginuser,
    LoginCollege,
    LoginuserEtc,
    Loginuser_gov
  },
  data() {
    return {
      showPasswordInfo: false,
      showThaidInfo: false,
      scoutPeriod: { open: false, stop: "" },

      readinessExpanded: true,
      readinessChecking: false,
      lastCheckedAt: null,
      readinessChecks: [
        { key: "browser", label: "เบราว์เซอร์ (Browser)", status: "pending", detail: "" },
        { key: "os", label: "ระบบปฏิบัติการ (OS)", status: "pending", detail: "" },
        { key: "storage", label: "การจัดเก็บข้อมูลในเบราว์เซอร์ (Cookies/localStorage)", status: "pending", detail: "" },
        { key: "internet", label: "การเชื่อมต่ออินเทอร์เน็ต", status: "pending", detail: "" },
        { key: "backend", label: "การเชื่อมต่อเซิร์ฟเวอร์ HRVEC", status: "pending", detail: "" },
        { key: "database", label: "ฐานข้อมูลระบบ", status: "pending", detail: "" },
        { key: "thaid_config", label: "การตั้งค่าระบบยืนยันตัวตน ThaiID", status: "pending", detail: "" },
        { key: "thaid_reachable", label: "การเชื่อมต่อระบบยืนยันตัวตน ThaiID (DOPA)", status: "pending", detail: "" },
        { key: "clock", label: "เวลาของเครื่องคอมพิวเตอร์", status: "pending", detail: "" }
      ]
    };
  },
  computed: {
    readinessSummary() {
      const hasFail = this.readinessChecks.some(i => i.status === "fail");
      const hasWarn = this.readinessChecks.some(i => i.status === "warn");
      const stillChecking = this.readinessChecks.some(i => i.status === "checking" || i.status === "pending");

      if (stillChecking) {
        return { color: "grey", icon: "mdi-timer-sand", text: "กำลังตรวจสอบความพร้อมของระบบ..." };
      }
      if (hasFail) {
        return { color: "error", icon: "mdi-close-circle", text: "พบปัญหาที่อาจทำให้เข้าสู่ระบบไม่ได้ — ดูรายละเอียดด้านล่าง" };
      }
      if (hasWarn) {
        return { color: "warning", icon: "mdi-alert", text: "พบข้อสังเกตบางรายการ — ดูรายละเอียดด้านล่าง" };
      }
      return { color: "success", icon: "mdi-check-circle", text: "ระบบพร้อมใช้งาน ไม่พบปัญหา" };
    },
    lastCheckedLabel() {
      if (!this.lastCheckedAt) return "ยังไม่ได้ตรวจสอบ";
      return this.lastCheckedAt.toLocaleTimeString("th-TH");
    }
  },
  async mounted() {
    this.runSystemReadinessCheck();
    await this.queryScoutPeriodStatus();
  },
  methods: {
    statusColor(status) {
      return { ok: "success", warn: "warning", fail: "error" }[status] || "grey";
    },
    statusIcon(status) {
      return { ok: "mdi-check-circle", warn: "mdi-alert", fail: "mdi-close-circle" }[status] || "mdi-help-circle-outline";
    },
    setCheck(key, status, detail) {
      const item = this.readinessChecks.find(i => i.key === key);
      if (item) {
        item.status = status;
        item.detail = detail;
      }
    },

    // ── ตรวจสอบเบราว์เซอร์ + OS (ฝั่งเครื่องผู้ใช้เอง ไม่ต้องเชื่อมต่อเซิร์ฟเวอร์) ──
    checkBrowserAndOs() {
      const ua = window.navigator.userAgent || "";

      let osName = "ไม่ทราบ";
      if (/Windows/.test(ua)) osName = "Windows";
      else if (/Mac OS X/.test(ua)) osName = "macOS";
      else if (/Android/.test(ua)) osName = "Android";
      else if (/iPhone|iPad|iPod/.test(ua)) osName = "iOS";
      else if (/Linux/.test(ua)) osName = "Linux";
      this.setCheck("os", "ok", `ตรวจพบระบบปฏิบัติการ: ${osName}`);

      const isIE = !!window.document.documentMode || /Trident\/|MSIE /.test(ua);
      const isOldEdge = /Edge\/\d+/.test(ua); // Edge เดิม (EdgeHTML) ต่างจาก Edge ใหม่ที่ใช้ Chromium (UA มี "Edg/")
      const edgMatch = ua.match(/Edg\/(\d+)/); // Edge ใหม่ (Chromium)
      const operaMatch = ua.match(/OPR\/(\d+)/);
      const chromeMatch = !edgMatch && !operaMatch && ua.match(/Chrom(?:e|ium)\/(\d+)/);
      const firefoxMatch = ua.match(/Firefox\/(\d+)/);
      const isSafariUa = !/Chrom(?:e|ium)|Edg\/|OPR\//.test(ua);
      const safariMatch = isSafariUa && ua.match(/Version\/(\d+).*Safari/);

      if (isIE || isOldEdge) {
        const name = isIE ? "Internet Explorer" : "Microsoft Edge (รุ่นเก่า)";
        this.setCheck(
          "browser",
          "fail",
          `ตรวจพบ ${name} ซึ่งอาจใช้งานระบบนี้ไม่ได้อย่างสมบูรณ์ แนะนำให้ใช้ Google Chrome, Microsoft Edge (รุ่นใหม่) หรือ Firefox เวอร์ชันล่าสุด`
        );
        return;
      }

      let browserName = "ไม่ทราบชนิดเบราว์เซอร์";
      let browserVersion = "";
      if (edgMatch) {
        browserName = "Microsoft Edge";
        browserVersion = edgMatch[1];
      } else if (operaMatch) {
        browserName = "Opera";
        browserVersion = operaMatch[1];
      } else if (chromeMatch) {
        browserName = "Google Chrome";
        browserVersion = chromeMatch[1];
      } else if (firefoxMatch) {
        browserName = "Firefox";
        browserVersion = firefoxMatch[1];
      } else if (safariMatch) {
        browserName = "Safari";
        browserVersion = safariMatch[1];
      }

      const isOutdated =
        (chromeMatch && Number(chromeMatch[1]) < 90) ||
        (firefoxMatch && Number(firefoxMatch[1]) < 88) ||
        (safariMatch && Number(safariMatch[1]) < 13);

      const label = `${browserName}${browserVersion ? " " + browserVersion : ""}`;
      if (isOutdated) {
        this.setCheck("browser", "warn", `ตรวจพบ ${label} ซึ่งเป็นเวอร์ชันเก่า แนะนำให้อัปเดตเป็นเวอร์ชันล่าสุด`);
      } else {
        this.setCheck("browser", "ok", `ตรวจพบ ${label}`);
      }
    },

    // ── ตรวจสอบว่าเบราว์เซอร์อนุญาตให้เก็บ localStorage ได้หรือไม่ (ระบบ login ต้องใช้เก็บ session) ──
    checkStorage() {
      try {
        const testKey = "__hrvec_storage_test__";
        window.localStorage.setItem(testKey, "1");
        window.localStorage.removeItem(testKey);
        this.setCheck("storage", "ok", "เบราว์เซอร์อนุญาตให้จัดเก็บข้อมูลได้ปกติ");
      } catch (e) {
        this.setCheck(
          "storage",
          "fail",
          "เบราว์เซอร์ไม่อนุญาตให้จัดเก็บข้อมูล (อาจอยู่ในโหมดส่วนตัว/ปิดการใช้งาน Cookies) ระบบจะไม่สามารถเข้าสู่ระบบได้ กรุณาปิดโหมดส่วนตัวหรืออนุญาตการจัดเก็บข้อมูลของเว็บไซต์นี้"
        );
      }
    },

    // ── ตรวจสอบทั้งหมด: ฝั่งเครื่องผู้ใช้ก่อน (ทันที) แล้วค่อยเรียกเซิร์ฟเวอร์เพื่อตรวจชั้นเครือข่าย/backend/ThaiID ──
    async runSystemReadinessCheck() {
      this.readinessChecking = true;
      this.readinessChecks.forEach(i => {
        i.status = "checking";
        i.detail = "";
      });

      this.checkBrowserAndOs();
      this.checkStorage();

      if (typeof navigator !== "undefined" && navigator.onLine === false) {
        this.setCheck("internet", "fail", "เครื่องของท่านไม่มีการเชื่อมต่ออินเทอร์เน็ต");
        this.setCheck("backend", "fail", "ข้ามการตรวจสอบ เนื่องจากไม่พบการเชื่อมต่ออินเทอร์เน็ต");
        this.setCheck("database", "warn", "ไม่สามารถตรวจสอบได้");
        this.setCheck("thaid_config", "warn", "ไม่สามารถตรวจสอบได้");
        this.setCheck("thaid_reachable", "warn", "ไม่สามารถตรวจสอบได้");
        this.setCheck("clock", "warn", "ไม่สามารถตรวจสอบได้");
        this.readinessChecking = false;
        this.lastCheckedAt = new Date();
        return;
      }
      this.setCheck("internet", "ok", "พบการเชื่อมต่ออินเทอร์เน็ต");

      const startedAt = Date.now();
      try {
        const result = await this.$http.post(
          "system_health_check.php",
          {},
          { timeout: 6000 }
        );
        const latencyMs = Date.now() - startedAt;
        const d = result.data || {};

        this.setCheck("backend", "ok", `เชื่อมต่อเซิร์ฟเวอร์ HRVEC สำเร็จ (${latencyMs} ms)`);

        if (d.database && d.database.ok) {
          this.setCheck("database", "ok", d.database.message);
        } else {
          this.setCheck("database", "fail", (d.database && d.database.message) || "เชื่อมต่อฐานข้อมูลไม่สำเร็จ");
        }

        if (d.thaid_config && d.thaid_config.ok) {
          this.setCheck("thaid_config", "ok", d.thaid_config.message);
        } else {
          this.setCheck("thaid_config", "fail", (d.thaid_config && d.thaid_config.message) || "ตั้งค่าระบบ ThaiID ไม่สมบูรณ์");
        }

        if (d.thaid_reachable && d.thaid_reachable.ok === true) {
          this.setCheck("thaid_reachable", "ok", d.thaid_reachable.message);
        } else if (d.thaid_reachable && d.thaid_reachable.ok === false) {
          this.setCheck("thaid_reachable", "fail", d.thaid_reachable.message);
        } else {
          this.setCheck("thaid_reachable", "warn", (d.thaid_reachable && d.thaid_reachable.message) || "ไม่ได้ตรวจสอบ");
        }

        if (d.server_time_unix) {
          const driftMs = Math.abs(Date.now() - d.server_time_unix * 1000);
          if (driftMs > 5 * 60 * 1000) {
            this.setCheck(
              "clock",
              "warn",
              "เวลาของเครื่องท่านคลาดเคลื่อนจากเซิร์ฟเวอร์มากกว่า 5 นาที อาจทำให้ลิงก์ยืนยันตัวตนหมดอายุเร็วผิดปกติ กรุณาตั้งเวลาเครื่องให้ตรง"
            );
          } else {
            this.setCheck("clock", "ok", "เวลาของเครื่องตรงกับเซิร์ฟเวอร์ปกติ");
          }
        } else {
          this.setCheck("clock", "warn", "ไม่สามารถตรวจสอบได้");
        }
      } catch (e) {
        this.setCheck("backend", "fail", "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ HRVEC ได้ในขณะนี้ — เซิร์ฟเวอร์อาจขัดข้องหรือปิดปรับปรุงชั่วคราว");
        this.setCheck("database", "warn", "ไม่สามารถตรวจสอบได้ เนื่องจากเชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ");
        this.setCheck("thaid_config", "warn", "ไม่สามารถตรวจสอบได้ เนื่องจากเชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ");
        this.setCheck("thaid_reachable", "warn", "ไม่สามารถตรวจสอบได้ เนื่องจากเชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ");
        this.setCheck("clock", "warn", "ไม่สามารถตรวจสอบได้ เนื่องจากเชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ");
      } finally {
        this.readinessChecking = false;
        this.lastCheckedAt = new Date();
      }
    },

    async queryScoutPeriodStatus() {
      try {
        const result = await this.$http.post("period_status.php", {
          ApiKey: "HRvec2021",
          period_type: "scout"
        });
        this.scoutPeriod.open = !!result.data.period_open;
        this.scoutPeriod.stop = result.data.period_stop || "";
      } catch (e) {
        this.scoutPeriod.open = false;
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap");
</style>

<style scoped>
.text_google {
  font-family: "Kanit", sans-serif;
}

.login-page {
  min-height: 100vh;
}

.brand-title {
  font-size: 2rem;
  font-weight: 700;
  color: #263238;
  margin-bottom: 4px;
}

.brand-subtitle {
  color: #718096;
  font-size: 1.05rem;
}

.manual-banner {
  border-radius: 12px;
}

.scout-banner {
  border-radius: 12px;
  animation: scout-banner-pop 0.4s ease-out;
  box-shadow: 0 4px 18px rgba(46, 125, 50, 0.25) !important;
}

.scout-banner-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1b5e20;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.scout-banner-desc {
  font-size: 0.98rem;
  line-height: 1.6;
  color: #1b5e20;
}

@keyframes scout-banner-pop {
  0% {
    opacity: 0;
    transform: translateY(-8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.readiness-card {
  border-radius: 12px;
  overflow: hidden;
}

.readiness-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  user-select: none;
}

.readiness-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #263238;
}

.readiness-summary {
  font-size: 0.82rem;
}

.readiness-summary--success {
  color: #2e7d32;
}

.readiness-summary--warning {
  color: #a86400;
}

.readiness-summary--error {
  color: #c62828;
}

.readiness-summary--grey {
  color: #757575;
}

.readiness-list {
  padding-top: 4px;
  padding-bottom: 4px;
}

.readiness-item-label {
  font-size: 0.88rem;
  font-weight: 600;
}

.readiness-item-detail {
  font-size: 0.8rem;
  white-space: normal;
  line-height: 1.5;
}

.readiness-footer {
  padding: 6px 16px 12px;
  font-size: 0.72rem;
  color: #9e9e9e;
  text-align: right;
}

.info-link {
  margin-left: 4px;
  font-weight: 600;
  text-decoration: underline;
  white-space: nowrap;
}

.password-info-header {
  background: linear-gradient(135deg, #455a64 0%, #455a64 100%);
}

.info-step p {
  font-size: 0.92rem;
  line-height: 1.5;
}

.group-guide-card {
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.guide-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #263238;
  line-height: 1.4;
}

.guide-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.guide-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}

.guide-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #263238;
}

.guide-desc {
  font-size: 0.98rem;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 0;
  padding-left: 22px;
}

.guide-thaid-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 22px;
  margin-top: 8px;
}

.guide-thaid-chip {
  font-weight: 600;
  pointer-events: none;
}

.thaid-link {
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: underline;
  white-space: nowrap;
}

.guide-note {
  font-size: 0.92rem;
}

.thaid-info-header {
  background: linear-gradient(135deg, #455a64 0%, #455a64 100%);
}

.thaid-intro {
  font-size: 0.96rem;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 20px;
}

@media (min-width: 960px) {
  .group-guide-card {
    position: sticky;
    top: 24px;
  }
}

@media (max-width: 600px) {
  .brand-title {
    font-size: 1.5rem;
  }

  .guide-name {
    font-size: 1rem;
  }

  .guide-desc {
    font-size: 0.94rem;
  }
}
</style>
